import type { BlueCityProjectDTO } from '@ui/shared/util-api';
import { ListItem } from '@ui/shared/util-list';

interface BlueCityDepartment {
    label: string;
    weblink?: string;
}

export class BlueCityItem extends ListItem {
    public readonly categories: Array<string>;
    public readonly sponsors: Array<string>;
    public readonly departments: Array<BlueCityDepartment>;
    public readonly description: string;
    public readonly imagePath: string;
    public readonly thumbnailPath: string;
    public readonly weblink: string;

    constructor(mapItem: BlueCityProjectDTO) {
        super(mapItem);

        this.categories = mapItem.categories.map(({ name }) => name);
        this.sponsors = mapItem.sponsors.map(({ name }) => name);
        this.departments = mapItem.departments.map(({ id, name, link }) => ({ id, label: name, weblink: link ?? undefined }));
        this.description = mapItem.short_description;
        this.imagePath = mapItem.image?.thumbs?.detail ?? mapItem.image?.image ?? '';
        this.thumbnailPath = mapItem.image?.thumbs?.preview ?? this.imagePath;
        this.weblink = mapItem.further_info_link;
    }
}
